<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="products mainwrap">
      <div class="container">
        <div class="proleft">
          <div class="procat">
            <div class="titleA"><strong>产品分类</strong></div>
            <ul class="catli">
              <li @click="filterByCategory()"
                :class="{ 'active-category': activeCategory === null || activeCategory === undefined }">全部产品</li>
              <li v-for="(x, index) in procat" :key="index" :class="{ 'active-category': activeCategory === x.id }"
                @click="filterByCategory(x.id)">
                {{ x.cat_name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="prolist">
          <div class="pro-itemwrap" v-if="products.length > 0">
            <div class="pro-item" v-for="product in products" :key="product.id">
              <div @click="viewProduct(product.id)">
                <img v-if="product.image" :src="product.image" class="image"
                  style="width: 100%;height:100%; object-fit: cover;">
                <div v-else>
                  <div
                    style="height: 100%; background: #f2f6fc; display: flex; align-items: center; justify-content: center; color: #909399;">
                    暂无图片
                  </div>
                </div>

                <div>
                  <h3>{{ product.name }}</h3>
                  <!-- <div class="product-description" v-html="product.description"></div> -->
                </div>
              </div>
            </div>
          </div>

          <div v-if="products.length === 0" class="nodata">
            <el-empty description="暂无产品信息"></el-empty>
          </div>

          <!-- 分页组件 -->
          <div class="pagination-wrapper" style="text-align: center; margin-top: 20px;">
            <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
              :page-size="pageSize" :total="total" layout="total, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品详情模态框 -->
    <el-dialog :visible.sync="productDetailVisible" :title="selectedProduct.name || '产品详情'" :width="isMobile?'96%':'50%'" top="20px"
      :before-close="closeProductDetail" class="product-detail-dialog">
      <div v-if="selectedProduct" class="product-detail-content">
        <div class="product-image">
          <img v-if="selectedProduct.image" :src="selectedProduct.image" alt="产品图片"
            style="width: 100%; height: auto; max-height: 400px; object-fit: contain;">
          <div v-else
            style="width: 100%; height: 300px; background: #f2f6fc; display: flex; align-items: center; justify-content: center; color: #909399;">
            暂无图片
          </div>
        </div>

        <div class="product-info">
          <div class="product-category">
            <label>所属类别:</label>
            <span>{{ getCategoryName(selectedProduct.category_id) }}</span>
          </div>


          <div class="product-description">
            <label>产品描述:</label>
            <div v-html="selectedProduct.description"></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageApi, productApi } from '@/api'

export default {
  name: 'Products',
  data() {
    return {
      pageContent: '',
      procat: [],
      products: [],
      currentPage: 1,
      pageSize: 9, // 每页3条记录
      total: 0,
      activeCategory: null,
      filterName: '',
      productDetailVisible: false, // 控制产品详情模态框显示/隐藏
      selectedProduct: '', // 当前选中的产品
      isMobile:false,
    }
  },
  created() {
    this.checkDeviceType()
    // 从URL查询参数中获取分类ID
    const catId = this.$route.query.catid ? parseInt(this.$route.query.catid) : null;
    this.activeCategory = catId;

    this.fetchAboutPage(4)
    this.getprocat()
    this.fetchProducts()
  },
  methods: {
    // 检测设备类型
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },

    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    },
    async getprocat() {
      try {
        const response = await productApi.getProductCat()
        if (response.code === 200) {
          this.procat = response.data
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    async fetchProducts() {
      try {
        const params = {
          page: this.currentPage,
          pagesize: this.pageSize
        }

        // 添加筛选参数
        if (this.activeCategory) {
          params.category_id = this.activeCategory
        }
        if (this.filterName) {
          params.name = this.filterName
        }

        const response = await productApi.getProductList(params)
        if (response.code === 200) {
          this.products = response.data.list
          this.total = response.data.total
          this.currentPage = response.data.page
          this.pageSize = response.data.pagesize
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchProducts()
    },
    filterByCategory(categoryId) {
      // 保存旧的分类ID用于比较
      const oldCategory = this.activeCategory;

      // 如果点击的是当前已选分类，则取消选择（设为null）
      this.activeCategory = categoryId === this.activeCategory ? null : categoryId;

      // 如果分类没有变化，则不执行路由更新
      if (oldCategory === this.activeCategory) {
        this.currentPage = 1; // 仍然需要重置页面并重新获取产品
        this.fetchProducts();
        return;
      }

      // 更新URL参数，保留其他参数
      const query = { ...this.$route.query };
      if (this.activeCategory) {
        query.catid = this.activeCategory;
      } else {
        // 如果是全部产品（activeCategory为null），则删除catid参数
        delete query.catid;
      }

      // 使用Vue Router的replace方法更新URL，但不触发页面刷新
      this.$router.replace({
        path: this.$route.path,
        query: query
      });

      this.currentPage = 1 // 重置到第一页
      this.fetchProducts()
    },
    async viewProduct(productId) {
      try {
        // 获取产品详情
        const response = await productApi.getProductById(productId);
        if (response.code === 200) {
          this.selectedProduct = response.data;
          this.productDetailVisible = true;
        } else {
          this.$message.error(response.msg || '获取产品详情失败');
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
        this.$message.error('获取产品详情失败');
      }
    },
    closeProductDetail() {
      this.productDetailVisible = false;
      this.selectedProduct = '';
    },
    getCategoryName(categoryId) {
      if (!categoryId) return '未分类';
      const category = this.procat.find(cat => cat.id === Number(categoryId));
      return category ? category.cat_name : '未知分类';
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;
}

.products {
  .container {
    display: flex;

    .titleA {
      font-size: 24px !important;
      margin-bottom: 10px !important;
    }

    .titleA strong::after {
      height: 24px !important;
      top: 8px !important
    }

    .proleft {
      width: 20%;
      padding: 30px 0;

      .titleA {
        border-bottom: 4px solid #004DB8;
        padding-left: 20px !important;
        margin-top: 10px !important;
        padding-bottom: 10px !important;
      }

      .titleA strong::after {
        left: 15px !important
      }

      .procat {
        border: 1px solid #eee;
        border-radius: 6px;
        background: #fff;

        ul {
          margin: 0;
          padding: 0;
        }

        ul li {
          margin: 0;
          padding: 15px 0;
          text-indent: 20px;
          list-style: none;
          border-bottom: 1px dashed #eee;
          font-size: 16px;
          cursor: pointer;
          font-weight: normal;
        }

        ul li:hover {
          color: #004DB8;
        }

        ul li.active-category {
          color: #004DB8;
          font-weight: bold;
        }

        ul li:last-child {
          border: none;
        }
      }

    }

    .prolist {
      padding: 30px 0 30px 50px;
      width: 80%;

      .nodata {
        border-radius: 6px;
        background: #fff;
        margin: 0 -10px;
        text-align: center;
        padding: 40px;
        color: #909399;
      }

      .pro-itemwrap {
        background: #fff;
        padding: 20px 10px 20px 20px;
        border-radius: 6px;
        display: flex;
        flex-wrap: wrap;
        margin: 0 -20px;
        gap: 20px;

        .pro-item {
          cursor: pointer;
          border-radius: 6px;
          border: 1px solid #eee;
          flex: 0 0 calc(33.333% - 20px);

          img {
            border-radius: 6px;
            width: 100%;
          }
        }

        .pro-item:hover {
          border: 1px solid #004DB8;
          color: #fff;
          background: #004DB8;
          transition: all 0.2s ease-in-out;
        }

        h3 {
          font-weight: normal;
          font-size: 16px;
          text-align: center;
          padding: 0 10px;
          margin: 5px 0;
        }
      }
    }
  }
}



.image {
  width: 100%;
  display: block;
}


.product-description {
  margin: 10px 0;
  color: #606266;
  line-height: 1.5;
  min-height: 60px;
}

.product-price {
  font-weight: bold;
  color: #E6A23C;
  margin: 10px 0;
  font-size: 16px;
}

.product-detail-content {

  .product-image {
    margin-bottom: 20px;
  }

  .product-info {
    >div {
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;
      white-space: pre;
    }

    label {
      font-weight: bold;
      display: inline-block;
      width: 80px;
      margin-bottom: 5px;
    }

    span,
    div {
      display: block;
      color: #333;
      white-space: break-spaces;
    }
  }

}

.product-detail-dialog {
  .el-dialog__header {
    background-color: #f5f7fa;
    padding: 10px 20px;
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  .products {
    .container {
      display: flex;
      flex-direction: column;

      .proleft {
        width: 100%;
      }

      .prolist {
        padding: 0 0 2rem 0;
        width: 100%;

        .pro-itemwrap {
          margin: 0;

          .pro-item {
            width: 100%;
            flex: auto;
          }
        }
      }
    }
  }
}
</style>